module.exports = __webpack_public_path__ + "img/portfolio_2.955666be.png";